import type { AxiosError } from "axios"
import * as v from "valibot"

export type HydraCollection<Member> = {
  "hydra:member": Array<Member>
  "hydra:totalItems": number
  "hydra:view"?: {
    "@id": string
    "@type": "hydra:PartialCollectionView"
    "hydra:first"?: string
    "hydra:last"?: string
    "hydra:next"?: string
    "hydra:previous"?: string
  }
}

export type Image = {
  title: string
  src: string
  "@type": "VichFile"
  "@id": string
}

export type ConstraintViolationError = AxiosError<ConstraintViolationList>

export type ConstraintViolation = {
  propertyPath: string
  message: string
  code: string
}

export type ConstraintViolationList = {
  "@id": string
  "@type": "ConstraintViolationList"
  status: number
  violations: Array<ConstraintViolation>
  detail: string
  "hydra:title": string
  "hydra:description": string
  type: string
  title: string
}

export type Enum<Type extends string, Value extends string> = {
  "@id": string
  "@type": Type
  enum_label: string
  enum_value: Value
  enum_color?: string | null
  enum_code?: string | null
}

export type Entity<
  Endpoint extends string = string,
  Type extends string = string,
  Properties extends Record<string, unknown> = Record<string, unknown>,
> = {
  "@id": `${Endpoint}/${number}`
  "@type": Type
  "@context": `/api/contexts/${Type}`
  createdAt: string
  updatedAt: string
  id: number
  __fqn: `App\\Entity\\${Type}`
  __toString: string
} & Properties

export type Embed<Type extends string, Properties> = {
  "@id": `/.well-known/genid/${string}`
  "@type": Type
  __fqn: `App\\Entity\\Embed\\${Type}`
  __toString: string
} & Properties

export const FileUploadSchema = v.object({
  uri: v.string(),
  type: v.string(),
  name: v.string(),
})

export type FileUpload = v.InferOutput<typeof FileUploadSchema>

export type MultipartFileUpload = FileUpload | "null"

export function isFileUpload(object: unknown): object is FileUpload {
  return v.safeParse(FileUploadSchema, object).success
}

export type DateFilter = {
  before?: string
  strictly_before?: string
  after?: string
  strictly_after?: string
}
